import React, { useEffect, useLayoutEffect } from "react";
import { useLessonDetails } from "../hooks/useLessonDetails";
import Lesson from "./Lesson";
import LessonDataCarta from "./LessonDataCarta";
import { LessonResourcesDownload } from "./lessons/LessonResourcesDownload";
import { LessonWrapper } from "./lessons/LessonWrapper";

const LessonMiddleware = ({ ...props }) => {
  const lessonId = props.id;
  const lesson = useLessonDetails(lessonId);
  const lessonType = Object.keys(lesson?.data || {})[0] || lesson?.type;

  useLayoutEffect(() => {
    if (
      lessonType === "LESSON_BOX" &&
      typeof props?.callToShowModeContinuous === "function"
    ) {
      props.callToShowModeContinuous();
    }
  }, [lessonType]);

  if (lessonType === 'LESSON_RESOURCES_DOWNLOAD') {
    const data = lesson?.data?.[lessonType];
    if (data === undefined) return null;
    return (
      <LessonWrapper
        autoCompleteOnRender={true}
        isLastLesson={props.hasNextLesson === false}
        onGoToNextLesson={props.onGoToNextLesson}
        onGoToChaptersView={props.onGoToChaptersView}
        onCompleted={props.onCompleted}>
        <LessonResourcesDownload description={data.description} resources={data.data} />
      </LessonWrapper>
    );
  }

  if (lessonType === "LESSON_CARTA")
    return (
      <LessonDataCarta
        lessonId={lessonId}
        hasNextLesson={props.hasNextLesson}
        goToNextLesson={props.onGoToNextLesson}
        backToEpisode={props.onGoToChaptersView}
        onSuccess={props.onCompleted}
        courseId={props.courseId}
        episodeId={props.episodeId}
        chapterId={props.chapterId}
      />
    );
  else return <Lesson {...props} id={lessonId} />;
};

export default LessonMiddleware;
